<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6">
    <div class="flex justify-between items-center mb-6">
       <div class="flex items-center space-x-2">
         <button (click)="goBackToList()" mat-icon-button class="text-gray-600 hover:text-gray-800">
           <mat-icon>arrow_back</mat-icon>
         </button>
         <h2 class="text-2xl font-bold mb-0">
           {{ isNewClient ? 'Neuanlage Kunde' : (isEditMode ? 'Kunde bearbeiten' : 'Kunde') }}: 
           <span *ngIf="!isNewClient && client">{{ client.suchbegriff }}</span>
         </h2>
         
       </div>

       <div class="flex space-x-2">
         
         
       </div>
     </div>
    <div class="row">
      <div class="col-md-12 order-md-1 order-sm-2">
        <!-- MAIN CONTENT START -->

        <!-- Loading State for Existing Client -->
        <div *ngIf="isLoading && !isNewClient" class="flex justify-center items-center py-8">
          <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
          <span class="ml-4 text-gray-600">Lade Kundendaten...</span>
        </div>



                 <!-- Combined View/Edit Mode -->
         <form [formGroup]="clientForm" [class.opacity-50]="isLoading && !isNewClient" [class.pointer-events-none]="isLoading && !isNewClient">
           <mat-tab-group animationDuration="0ms" *ngIf="!isNewClient" (selectedIndexChange)="selectedTabIndex = $event" [selectedIndex]="selectedTabIndex">
             <mat-tab label="Kunde Information">
               <div class="step-container d-flex align-items-start flex-column">
                 <div class="container-fluid mt-6">
                   <div class="form">
                     <div class="row">
                       <div class="col-12 col-lg-6">
                        <!-- Suchbegriff -->
                        <div class="form-group">
                          <label class="form-label" for="suchbegriff">Name *</label>
                          <!-- View Mode -->
                          <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                            {{ client?.suchbegriff || '-' }}
                          </div>
                          <!-- Edit Mode -->
                          <input
                            *ngIf="isEditMode || isNewClient"
                            type="text"
                            class="form-control"
                            id="suchbegriff"
                            formControlName="suchbegriff"
                            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            placeholder="Name"
                            [class.is-invalid]="isFieldInvalid('suchbegriff')" />
                          <div *ngIf="isFieldInvalid('suchbegriff')" class="text-red-500 text-sm">Name is required</div>
                        </div>


                         <!-- Status ID -->
                         <div class="form-group">
                           <label class="form-label" for="status_id">Status</label>
                           <!-- View Mode -->
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.status_id ? getStatusText(client.status_id) : '-' }}
                           </div>
                           <!-- Edit Mode -->
                           <select
                             *ngIf="isEditMode || isNewClient"
                             class="form-control"
                             id="status_id"
                             formControlName="status_id"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
                             <option *ngFor="let status of clientStatusOptions" [value]="status.id">
                               {{ status.label }}
                             </option>
                           </select>
                         </div>

                         <!-- Techniker Projekthinweis - HIDDEN -->
                         <div class="form-group" *ngIf="false">
                           <label class="form-label" for="techniker_projekthinweis">Techniker Projekthinweis</label>
                           <!-- View Mode -->
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.techniker_projekthinweis || '-' }}
                           </div>
                           <!-- Edit Mode -->
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="text"
                             class="form-control"
                             id="techniker_projekthinweis"
                             formControlName="techniker_projekthinweis"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                             placeholder="Techniker Projekthinweis" />
                         </div>

                         <!-- Startdatum -->
                         <div class="form-group">
                           <label class="form-label" for="startdatum">Vertragsbeginn</label>
                           <!-- View Mode -->
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ formatDateForDisplay(client?.startdatum) || '-' }}
                           </div>
                           <!-- Edit Mode -->
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="date"
                             class="form-control"
                             id="startdatum"
                             formControlName="startdatum"
                             placeholder="DD.MM.YYYY"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" />
                         </div>

                         <!-- Enddatum -->
                         <div class="form-group">
                           <label class="form-label" for="enddatum">Vertragsende</label>
                           <!-- View Mode -->
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ formatDateForDisplay(client?.enddatum) || '-' }}
                           </div>
                           <!-- Edit Mode -->
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="date"
                             class="form-control"
                             id="enddatum"
                             formControlName="enddatum"
                             placeholder="DD.MM.YYYY"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" />
                         </div>

                         <!-- Address Section -->
                         <div class="form-group">
                           <label class="form-label" for="strasse">Straße</label>
                           <!-- View Mode -->
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.strasse || '-' }}
                           </div>
                           <!-- Edit Mode -->
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="text"
                             class="form-control"
                             id="strasse"
                             formControlName="strasse"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                             placeholder="Straße" />
                           <div *ngIf="clientForm.get('strasse')?.invalid && clientForm.get('strasse')?.touched" class="text-red-500 text-sm">
                             Straße darf maximal 255 Zeichen haben
                           </div>
                         </div>

                         <div class="form-group">
                           <label class="form-label" for="plz">PLZ</label>
                           <!-- View Mode -->
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.plz || '-' }}
                           </div>
                           <!-- Edit Mode -->
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="text"
                             class="form-control"
                             id="plz"
                             formControlName="plz"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                             placeholder="PLZ" />
                           <div *ngIf="clientForm.get('plz')?.invalid && clientForm.get('plz')?.touched" class="text-red-500 text-sm">
                             PLZ darf maximal 10 Zeichen haben
                           </div>
                         </div>

                         <div class="form-group">
                           <label class="form-label" for="ort">Ort</label>
                           <!-- View Mode -->
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.ort || '-' }}
                           </div>
                           <!-- Edit Mode -->
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="text"
                             class="form-control"
                             id="ort"
                             formControlName="ort"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                             placeholder="Ort" />
                           <div *ngIf="clientForm.get('ort')?.invalid && clientForm.get('ort')?.touched" class="text-red-500 text-sm">
                             Ort darf maximal 255 Zeichen haben
                           </div>
                         </div>

                         <div class="form-group">
                           <label class="form-label" for="land">Land</label>
                           <!-- View Mode -->
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.land || '-' }}
                           </div>
                           <!-- Edit Mode -->
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="text"
                             class="form-control"
                             id="land"
                             formControlName="land"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                             placeholder="Land" />
                           <div *ngIf="clientForm.get('land')?.invalid && clientForm.get('land')?.touched" class="text-red-500 text-sm">
                             Land darf maximal 100 Zeichen haben
                           </div>
                         </div>
                       </div>


                       <div class="col-12 col-lg-6">
                         <!-- Anmeldung Besuche - HIDDEN -->
                         <div class="form-group" *ngIf="false">
                           <label class="form-label" for="anmeldung_besuche">Anmeldung Besuche</label>
                           <!-- View Mode -->
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.anmeldung_besuche || '-' }}
                           </div>
                           <!-- Edit Mode -->
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="text"
                             class="form-control"
                             id="anmeldung_besuche"
                             formControlName="anmeldung_besuche"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                             placeholder="Anmeldung Besuche" />
                         </div>

                         <!-- Periode Aufgaben Vorschlagen -->
                         <div *ngIf="false" class="form-group">
                           <label class="form-label" for="periode_aufgaben_vorschlagen">Periode Aufgaben Vorschlagen</label>
                           <!-- View Mode -->
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.periode_aufgaben_vorschlagen === 1 ? 'Ja' : (client?.periode_aufgaben_vorschlagen === 0 ? 'Nein' : '-') }}
                           </div>
                           <!-- Edit Mode -->
                           <select
                             *ngIf="isEditMode || isNewClient"
                             class="form-control"
                             id="periode_aufgaben_vorschlagen"
                             formControlName="periode_aufgaben_vorschlagen"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
                             <option value="0">Nein</option>
                             <option value="1">Ja</option>
                           </select>
                         </div>

                         <!-- Ueberpruefung Erforderlich -->
                         <div *ngIf="false" class="form-group">
                           <label class="form-label" for="ueberpruefung_erforderlich">Ueberpruefung Erforderlich</label>
                           <!-- View Mode -->
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ formatDateForDisplay(client?.ueberpruefung_erforderlich) || '-' }}
                           </div>
                           <!-- Edit Mode -->
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="date"
                             class="form-control"
                             id="ueberpruefung_erforderlich"
                             formControlName="ueberpruefung_erforderlich"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                             placeholder="DD.MM.YYYY" />
                         </div>

                         <!-- Wiederkehrende Aufgaben Vorhanden -->
                         <div *ngIf="false" class="form-group">
                           <label class="form-label" for="wiederkehrende_aufgaben_vorhanden">Wiederkehrende Aufgaben Vorhanden</label>
                           <!-- View Mode -->
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.wiederkehrende_aufgaben_vorhanden === 1 ? 'Ja' : (client?.wiederkehrende_aufgaben_vorhanden === 0 ? 'Nein' : '-') }}
                           </div>
                           <!-- Edit Mode -->
                           <select
                             *ngIf="isEditMode || isNewClient"
                             class="form-control"
                             id="wiederkehrende_aufgaben_vorhanden"
                             formControlName="wiederkehrende_aufgaben_vorhanden"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
                             <option value="0">Nein</option>
                             <option value="1">Ja</option>
                           </select>
                         </div>

                         <!-- Datum Letzte Wiederkehrende Aufgabe -->
                         <div *ngIf="false" class="form-group">
                           <label class="form-label" for="datum_letzte_wiederkehrende_aufgabe">Datum Letzte Wiederkehrende Aufgabe</label>
                           <!-- View Mode -->
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ formatDateForDisplay(client?.datum_letzte_wiederkehrende_aufgabe) || '-' }}
                           </div>
                           <!-- Edit Mode -->
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="date"
                             class="form-control"
                             id="datum_letzte_wiederkehrende_aufgabe"
                             formControlName="datum_letzte_wiederkehrende_aufgabe"
                             placeholder="DD.MM.YYYY"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" />
                         </div>

                          <!-- Anmerkungen Chat Section -->
                          <div class="form-group" *ngIf="!isEditMode && !isNewClient">
                            <div class="flex items-center justify-between mb-2">
                              <label class="form-label mb-0" for="anmerkungen">Anmerkungen</label>
                              <span *ngIf="sortedAnmerkungen && sortedAnmerkungen.length > 0" 
                                    class="px-2 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full">
                                {{ sortedAnmerkungen.length }}
                              </span>
                            </div>

                            <!-- Anmerkungen List (scrollable) -->
                            <div *ngIf="sortedAnmerkungen && sortedAnmerkungen.length > 0" 
                                 class="space-y-2 max-h-[350px] overflow-y-auto pr-2 mb-4 border border-gray-200 rounded-lg p-3 bg-gray-50">
                              <div *ngFor="let anmerkung of sortedAnmerkungen; let i = index" 
                                   class="flex items-start gap-3 p-3 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                                <!-- User Avatar -->
                                <div class="flex-shrink-0">
                                  <div class="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white text-sm font-medium">
                                    {{ getUserInitials(anmerkung.username) }}
                                  </div>
                                </div>
                                
                                <!-- Anmerkung Content -->
                                <div class="flex-1 min-w-0">
                                  <!-- Username and Date -->
                                  <div class="flex items-center gap-2 mb-1">
                                    <span class="text-sm font-medium text-gray-900">
                                      {{ anmerkung.username }}
                                    </span>
                                    <span class="text-xs text-gray-500">
                                      {{ formatAnmerkungDate(anmerkung.datetime) }}
                                    </span>
                                  </div>
                                  
                                  <!-- Anmerkung Text -->
                                  <div class="text-sm text-gray-700 whitespace-pre-wrap">
                                    {{ anmerkung.anmerkung }}
                                  </div>
                                </div>
                                
                                <!-- Action Button (admin only - delete only) -->
                                <div *ngIf="canEditAnmerkungen()" 
                                     class="flex-shrink-0">
                                  <button
                                    (click)="deleteAnmerkung(anmerkung)"
                                    mat-icon-button
                                    class="mat-icon-button-small"
                                    title="Löschen">
                                    <mat-icon>close</mat-icon>
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Empty State -->
                            <div *ngIf="!sortedAnmerkungen || sortedAnmerkungen.length === 0" 
                                 class="text-center py-6 text-sm text-gray-500 mb-4 border border-gray-200 rounded-lg bg-gray-50">
                              <mat-icon class="w-8 h-8 mb-2 text-gray-400">comment</mat-icon>
                              <p>Noch keine Anmerkungen</p>
                            </div>

                            <!-- Add New Anmerkung Section -->
                            <div class="mt-4">
                              <label class="block text-sm font-medium text-gray-700 mb-2">Neue Anmerkung hinzufügen</label>
                              <textarea
                                #anmerkungTextarea
                                [(ngModel)]="newAnmerkungText"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="onAnmerkungTextChange($event)"
                                [disabled]="isAddingAnmerkung"
                                rows="3"
                                class="w-full p-2.5 border border-gray-300 rounded-lg text-sm focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Anmerkung eingeben..."></textarea>
                              <div class="flex justify-end mt-2">
                                <button
                                  type="button"
                                  (click)="addAnmerkungFromTemplate($event)"
                                  [disabled]="!canAddAnmerkung"
                                  mat-raised-button
                                  color="primary"
                                  class="!text-xs !px-4 !py-1.5 !h-auto !min-h-0">
                                  <span *ngIf="isAddingAnmerkung">Hinzufügen...</span>
                                  <span *ngIf="!isAddingAnmerkung">Hinzufügen</span>
                                </button>
                              </div>
                              <p *ngIf="isNewClient" class="text-xs text-gray-500 mt-1">
                                Anmerkungen werden beim Speichern des Kunden gespeichert.
                              </p>
                            </div>
                          </div>
                       </div>

                       <div class="col-12">
                         <!-- Bemerkung Next Evaluation -->
                         <div *ngIf="false" class="form-group">
                           <label class="form-label" for="bemerkung_next_evaluation">Bemerkung Next Evaluation</label>
                           <!-- View Mode -->
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.bemerkung_next_evaluation || '-' }}
                           </div>
                           <!-- Edit Mode -->
                           <textarea
                             *ngIf="isEditMode || isNewClient"
                             class="form-control"
                             id="bemerkung_next_evaluation"
                             formControlName="bemerkung_next_evaluation"
                             rows="4"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                             placeholder="Bemerkung Next Evaluation"></textarea>
                         </div>
                       </div>

                      <!-- Action Buttons moved below tabs (global bottom bar) -->
                   </div>
                </div>
              </div>
              </div>
            </mat-tab>
             
                           <mat-tab label="Kontakte">
                <div class="kontakte-tab-content w-11/12 mx-auto">
                  <app-kontakte 
                    *ngIf="!isNewClient && client?.uuid" 
                    [kundeId]="client.uuid"
                    [isEmbedded]="true"
                    [parentContext]="'client-edit'">
                  </app-kontakte>
                  <div *ngIf="isNewClient || !client?.uuid" class="text-center py-8">
                    <mat-icon class="text-gray-400 text-6xl mb-4">contacts</mat-icon>
                    <p class="text-gray-500 text-lg">Kontakte werden nach dem Speichern des Kunden verfügbar</p>
                  </div>
                </div>
              </mat-tab>
              
              <mat-tab label="Standorte">
                <div class="standorte-tab-content w-11/12 mx-auto">
                  <app-standorte 
                    *ngIf="!isNewClient && client?.uuid" 
                    [kundeId]="client.uuid"
                    [isEmbedded]="true"
                    [parentContext]="'client-edit'">
                  </app-standorte>
                  <div *ngIf="isNewClient || !client?.uuid" class="text-center py-8">
                    <mat-icon class="text-gray-400 text-6xl mb-4">location_on</mat-icon>
                    <p class="text-gray-500 text-lg">Standorte werden nach dem Speichern des Kunden verfügbar</p>
                  </div>
                </div>
              </mat-tab>
              
              <mat-tab label="Dokumente">
                <div class="dokumente-tab-content w-11/12 mx-auto">
                  <app-dokumente 
                    *ngIf="!isNewClient && client?.uuid" 
                    [tableName]="'standort'"
                    [isClientView]="true"
                    [clientId]="client.uuid"
                    [isEmbedded]="true"
                    [parentContext]="'client-edit'">
                  </app-dokumente>
                  <div *ngIf="isNewClient || !client?.uuid" class="text-center py-8">
                    <mat-icon class="text-gray-400 text-6xl mb-4">folder</mat-icon>
                    <p class="text-gray-500 text-lg">Dokumente werden nach dem Speichern des Kunden verfügbar</p>
                  </div>
                </div>
              </mat-tab>
           </mat-tab-group>

           <!-- Bottom action bar for existing client (visible only on first tab: Kunde Information) -->
           <div *ngIf="!isNewClient && selectedTabIndex === 0" class="mt-6 flex justify-between items-center">
             <!-- Left side - Delete button -->
             <div>
               <button
                 *ngIf="client && isEditMode"
                 (click)="deleteClient()"
                 mat-button
                 color="warn">
                 Löschen
               </button>
             </div>

             <!-- Right side - Action buttons -->
             <div class="flex space-x-4">
               <button
                 *ngIf="client && !isEditMode"
                 (click)="enterEditMode()"
                 mat-raised-button
                 color="primary">
                 Bearbeiten
               </button>

               <button
                 *ngIf="client && isEditMode"
                 (click)="cancelEdit()"
                 mat-button>
                 Abbrechen
               </button>

               <button
                 *ngIf="client && isEditMode"
                 (click)="saveClient()"
                 [disabled]="!clientForm.valid || isSaving"
                 mat-raised-button
                 color="primary">
                 <span *ngIf="isSaving">Speichern...</span>
                 <span *ngIf="!isSaving">Speichern</span>
               </button>
             </div>
           </div>

           <!-- New Client Form (No Tabs) -->
           <div *ngIf="isNewClient" class="step-container d-flex align-items-start flex-column">
             <div class="container-fluid mt-6">
               <div class="form">
                 <div class="row">
                   <div class="col-12 col-lg-6">
                     <!-- Suchbegriff -->
                     <div class="form-group">
                       <label class="form-label" for="suchbegriff">Name *</label>
                       <input
                         type="text"
                         class="form-control"
                         id="suchbegriff"
                         formControlName="suchbegriff"
                         placeholder="Kundenname eingeben"
                         [class.is-invalid]="clientForm.get('suchbegriff')?.invalid && clientForm.get('suchbegriff')?.touched"
                       />
                       <div *ngIf="clientForm.get('suchbegriff')?.invalid && clientForm.get('suchbegriff')?.touched" class="invalid-feedback">
                         Name ist erforderlich
                       </div>
                     </div>
                   </div>

                   <div class="col-12 col-lg-6">
                     <!-- Status -->
                     <div class="form-group">
                       <label class="form-label" for="status_id">Status</label>
                       <select
                         class="form-control"
                         id="status_id"
                         formControlName="status_id"
                       >
                         <option *ngFor="let status of clientStatusOptions" [value]="status.id">
                           {{ status.label }}
                         </option>
                       </select>
                     </div>
                   </div>

                   <div class="col-12">
                     <!-- Techniker Projekthinweis - HIDDEN -->
                     <div class="form-group" *ngIf="false">
                       <label class="form-label" for="techniker_projekthinweis">Techniker Projekthinweis</label>
                       <textarea
                         class="form-control"
                         id="techniker_projekthinweis"
                         formControlName="techniker_projekthinweis"
                         rows="3"
                         placeholder="Projekthinweis eingeben"
                       ></textarea>
                     </div>
                   </div>

                   <div class="col-12 col-lg-6">
                     <!-- Vertragsbeginn -->
                     <div class="form-group">
                       <label class="form-label" for="startdatum">Vertragsbeginn</label>
                       <input
                         type="date"
                         class="form-control"
                         id="startdatum"
                         formControlName="startdatum"
                         placeholder="DD.MM.YYYY"
                       />
                     </div>
                   </div>

                   <div class="col-12 col-lg-6">
                     <!-- Vertragsende -->
                     <div class="form-group">
                       <label class="form-label" for="enddatum">Vertragsende</label>
                       <input
                         type="date"
                         class="form-control"
                         id="enddatum"
                         formControlName="enddatum"
                         placeholder="DD.MM.YYYY"
                       />
                     </div>
                   </div>

                   <div class="col-12">
                     <!-- Anmeldung Besuche - HIDDEN -->
                     <div class="form-group" *ngIf="false">
                       <label class="form-label" for="anmeldung_besuche">Anmeldung Besuche</label>
                       <textarea
                         class="form-control"
                         id="anmeldung_besuche"
                         formControlName="anmeldung_besuche"
                         rows="2"
                         placeholder="Anmeldungshinweise eingeben"
                       ></textarea>
                     </div>
                   </div>

                   <div class="col-12 col-lg-6">
                     <!-- Periode Aufgaben Vorschlagen -->
                     <div *ngIf="false" class="form-group">
                       <label class="form-label" for="periode_aufgaben_vorschlagen">Periode Aufgaben Vorschlagen</label>
                       <select
                         class="form-control"
                         id="periode_aufgaben_vorschlagen"
                         formControlName="periode_aufgaben_vorschlagen"
                       >
                         <option *ngFor="let periode of periodeAufgabenOptions" [value]="periode.id">
                           {{ periode.label }}
                         </option>
                       </select>
                     </div>
                   </div>

                   <div class="col-12 col-lg-6">
                     <!-- Überprüfung Erforderlich -->
                     <div *ngIf="false" class="form-group">
                       <label class="form-label" for="ueberpruefung_erforderlich">Überprüfung Erforderlich</label>
                       <input
                         type="date"
                         class="form-control"
                         id="ueberpruefung_erforderlich"
                         formControlName="ueberpruefung_erforderlich"
                         placeholder="DD.MM.YYYY"
                       />
                     </div>
                   </div>

                   <div class="col-12">
                     <!-- Bemerkung Next Evaluation -->
                     <div *ngIf="false" class="form-group">
                       <label class="form-label" for="bemerkung_next_evaluation">Bemerkung Next Evaluation</label>
                       <textarea
                         class="form-control"
                         id="bemerkung_next_evaluation"
                         formControlName="bemerkung_next_evaluation"
                         rows="2"
                         placeholder="Bemerkung eingeben"
                       ></textarea>
                     </div>
                   </div>

                   <div class="col-12 col-lg-6">
                     <!-- Wiederkehrende Aufgaben Vorhanden -->
                     <div *ngIf="false" class="form-group">
                       <div class="form-check">
                         <input
                           type="checkbox"
                           class="form-check-input"
                           id="wiederkehrende_aufgaben_vorhanden"
                           formControlName="wiederkehrende_aufgaben_vorhanden"
                         />
                         <label class="form-check-label" for="wiederkehrende_aufgaben_vorhanden">
                           Wiederkehrende Aufgaben Vorhanden
                         </label>
                       </div>
                     </div>
                   </div>

                   <div class="col-12 col-lg-6">
                     <!-- Datum Letzte Wiederkehrende Aufgabe -->
                     <div *ngIf="false" class="form-group">
                       <label class="form-label" for="datum_letzte_wiederkehrende_aufgabe">Datum Letzte Wiederkehrende Aufgabe</label>
                       <input
                         type="date"
                         class="form-control"
                         id="datum_letzte_wiederkehrende_aufgabe"
                         formControlName="datum_letzte_wiederkehrende_aufgabe"
                         placeholder="DD.MM.YYYY"
                       />
                     </div>
                   </div>

                 </div>
               </div>
               <!-- Action Buttons for New Client -->
               <div class="col-12 mt-6">
                 <div class="flex justify-end space-x-4">
                   <button (click)="cancel()" mat-button>Abbrechen</button>
                   <button (click)="saveClient()" [disabled]="!clientForm.valid || isSaving" mat-raised-button color="primary">
                     <span *ngIf="isSaving">Erstellen...</span>
                     <span *ngIf="!isSaving">Erstellen</span>
                   </button>
                 </div>
               </div>
             </div>
           </div>
         </form>
 

       </div>
     </div>
   </div>
 </div>
